import { useContext, useState } from "react";
import { ConfigureAnalyzeSassPrintersList } from "./AnalyzeInterface";
import { ApplicationContext } from "../../components/ApplicationProvider";
import {
    TotalPrintersStatement,
    LabelPrinter,
    PrinterList,
    PrinterRow,
    PrinterTableContainer,
    AnalyzeSaaSTagTableCell,
    PrinterTable,
    PrinterTableHeader,
    EllipsisText,
} from "./AnalyzeStyle";
import { PaginationLinks } from "../../view/Navigation/PaginationLinks";

export const ListPrinterTable = ({
    listOfPrinters = [],
    streamlineProLicenceCount = 0,
}: {
    listOfPrinters?: ConfigureAnalyzeSassPrintersList[];
    streamlineProLicenceCount?: number;
}) => {
    const { t } = useContext(ApplicationContext);
    const PRINTERS_PER_PAGE = 5;
    const [page, setPage] = useState(1);

    const sortedPrinters = [...listOfPrinters].sort((a, b) =>
        (a.serialNumber ?? "").localeCompare(b.serialNumber ?? "")
    );

    const paginatedPrinters = sortedPrinters.slice(
        (page - 1) * PRINTERS_PER_PAGE,
        page * PRINTERS_PER_PAGE
    );

    return (
        <PrinterList>
            <TotalPrintersStatement>
                {t("configure_analyze.configure_analyze_sass.streamline_pro_available_licenses", {
                    license_count: streamlineProLicenceCount,
                })}
            </TotalPrintersStatement>
            <h3>{t("configure_analyze.configure_analyze_sass.connected_printers")}</h3>
            <PrinterTableContainer>
                <PrinterTable className="ui table" id="saasPrintersList" style={{ border: 0 }}>
                    <PrinterTableHeader>
                        <tr>
                            <th>{t("configure_analyze.configure_analyze_sass.serial_no")}</th>
                            <th>{t("configure_analyze.configure_analyze_sass.printer_model")}</th>
                            <th></th>
                            <th>{t("configure_analyze.configure_analyze_sass.license")}</th>
                            <th>{t("configure_analyze.configure_analyze_sass.license_start")}</th>
                            <th>{t("configure_analyze.configure_analyze_sass.license_expiry")}</th>
                            <th>{t("configure_analyze.configure_analyze_sass.channel")}</th>
                        </tr>
                    </PrinterTableHeader>
                    <tbody>
                        {paginatedPrinters.length > 0 ? (
                            paginatedPrinters.map((printer) => (
                                <PrinterRow key={printer.serialNumber}>
                                    <td data-label="SerialNumber">{printer.serialNumber}</td>
                                    <td data-label="Model">
                                        <AnalyzeSaaSTagTableCell>
                                            <EllipsisText>{printer.printerModel}</EllipsisText>
                                        </AnalyzeSaaSTagTableCell>
                                    </td>
                                    <td data-label="PrinterTag">
                                        {printer.tag && <LabelPrinter>{printer.tag}</LabelPrinter>}
                                    </td>
                                    <td data-label="License">{printer.license}</td>
                                    <td data-label="LicenseStart">
                                        {printer.licenseStart &&
                                            new Date(printer.licenseStart).toDateString()}
                                    </td>
                                    <td data-label="LicenseExpiry">
                                        {printer.licenseExpiry &&
                                            new Date(printer.licenseExpiry).toDateString()}
                                    </td>
                                    <td data-label="Channel">{printer.channel}</td>
                                </PrinterRow>
                            ))
                        ) : (
                            <tr>
                                <td colSpan={7} style={{ textAlign: "center" }}>
                                    {t(
                                        "configure_analyze.configure_analyze_sass.no_printers_message"
                                    )}
                                </td>
                            </tr>
                        )}
                    </tbody>
                </PrinterTable>
            </PrinterTableContainer>
            <tfoot>
                <tr>
                    <td>
                        <PaginationLinks
                            total={listOfPrinters.length}
                            perPage={PRINTERS_PER_PAGE}
                            currentPage={page}
                            goToPage={setPage}
                        />
                    </td>
                </tr>
            </tfoot>
        </PrinterList>
    );
};
